export function cpicker(_ctx) {
    return {
        styles: {
            main: { bg_color: '#000000', bg_opa: 255, scale_width: 15, pad_inner: 10, radius: 999 },
            // indicator = cpicker_indic
            indicator: { border_width: 2, border_color: '#ffffff' },
        },
    };
}
